export default __webpack_public_path__ + "static/media/beeframe-2.767ca749.svg";